import { render, staticRenderFns } from "./ServiceLogo.vue?vue&type=template&id=0cd4615c&scoped=true&"
import script from "./ServiceLogo.vue?vue&type=script&lang=js&"
export * from "./ServiceLogo.vue?vue&type=script&lang=js&"
import style0 from "./ServiceLogo.vue?vue&type=style&index=0&id=0cd4615c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4615c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd4615c')) {
      api.createRecord('0cd4615c', component.options)
    } else {
      api.reload('0cd4615c', component.options)
    }
    module.hot.accept("./ServiceLogo.vue?vue&type=template&id=0cd4615c&scoped=true&", function () {
      api.rerender('0cd4615c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/sp/ServiceLogo/ServiceLogo.vue"
export default component.exports